import type { schemas } from '@gonfalon/openapi/types';
import { Icon } from '@launchpad-ui/icons';
import clsx from 'clsx';

import { VariationColor } from '../../../ui/VariationColor';
import { getFlagVariationDisplayValue } from '../../../utils/getFlagVariationDisplayValue';

import styles from './VariationDisplay.module.css';

type Variation = schemas['Variation'];

type DisplayOptions = NonNullable<Parameters<typeof getFlagVariationDisplayValue>[1]>;

export type VariationDisplayProps = {
  variation: Variation;
  variationIndex: number;
  className?: string;
  compact?: boolean;
  multiple?: boolean;
} & DisplayOptions;

export function VariationDisplay({
  variation,
  variationIndex,
  className,
  compact = false,
  multiple = false,
  ...displayOptions
}: VariationDisplayProps) {
  const color = 'color' in variation && variation.color ? variation.color : undefined;
  const variationDisplayName = getFlagVariationDisplayValue(variation, displayOptions);
  const hasDisplayText = variationDisplayName && variationDisplayName.trim().length > 0;
  return (
    <div className={clsx(styles.variation, className)}>
      {multiple ? (
        <Icon name="diamonds" size="small" className={styles.allVariationsIcon} />
      ) : (
        <VariationColor variationIndex={variationIndex} className={styles.color} overrideColor={color} />
      )}
      {!compact && hasDisplayText && (
        <div title={variationDisplayName} className={styles.display}>
          {variationDisplayName}
        </div>
      )}
    </div>
  );
}
